import React from "react";

import {
  REPORT_EDIT_CONTROLS,
  getReportEditValue,
  type Finding,
} from "../utils/utils";

type FindingEditControlProps = {
  finding: Finding;
  reportEdits: Record<string, string>;
  formatOptionLabel: (label: string) => string;
  onChange: (finding: Finding, backendKey: string, value: string) => void;
};

const controlClass =
  "w-full h-10 rounded-lg border border-blue-200 dark:border-blue-700 bg-white dark:bg-gray-800 px-3 text-sm font-semibold text-slate-900 dark:text-white shadow-sm outline-none transition focus:border-blue-400 dark:focus:border-blue-500 focus:ring-2 focus:ring-blue-100 dark:focus:ring-blue-900/40";

export const FindingEditControl = ({
  finding,
  reportEdits,
  formatOptionLabel,
  onChange,
}: FindingEditControlProps) => {
  const control = REPORT_EDIT_CONTROLS[finding.fieldKey];
  if (!control) {
    return null;
  }

  const value = getReportEditValue(finding, control, reportEdits);

  if (control.type === "select") {
    return (
      <select
        aria-label={`Edit ${finding.title}`}
        value={value}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) =>
          onChange(finding, control.backendKey, event.target.value)
        }
        className={controlClass}
      >
        <option value="">Select result</option>
        {control.options?.map((option) => (
          <option key={option.value} value={option.value}>
            {formatOptionLabel(option.label)}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="relative" onClick={(event) => event.stopPropagation()}>
      <input
        aria-label={`Edit ${finding.title}`}
        type="number"
        value={value}
        min={control.min}
        step={control.step}
        placeholder={control.placeholder}
        onChange={(event) =>
          onChange(finding, control.backendKey, event.target.value)
        }
        className={`${controlClass} pr-14`}
      />
      {control.placeholder && (
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs font-semibold text-slate-400 dark:text-gray-500">
          {control.placeholder}
        </span>
      )}
    </div>
  );
};
